import { gql } from '@apollo/client';

export const DELETE_INVIATION_TEMPLATE = gql`
  mutation deletePublisherInvitation($id: ID!) {
    deletePublisherInvitation(id: $id)
  }
`;
